// extracted by mini-css-extract-plugin
export default {"root":"Checkbox_root__mtaeA","label":"Checkbox_label__O31PG","checkboxMargin":"Checkbox_checkboxMargin__wVQWI"};